import { PasswordInput } from "@/app/components/PasswordInput";
import { useState } from "react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { closeModal } from "../../../components/modal";
import { useToastEffect } from "../../../hooks";
import { useEnrollCourseMutation } from "../../../services/courseApi";
import { ENROLL_COURSE_MODAL_ID } from "../HomePage";
import { SEARCH_MODAL_ID } from "../SearchCoursesModal";

export type CourseInfo = {
  id: string;
  name: string;
};

export const EnrollCourseMask = ({
  course,
  resetMask,
}: { course: CourseInfo; resetMask: boolean }) => {
  const [enrollCourse, { isError, isSuccess, reset }] =
    useEnrollCourseMutation();
  const [password, setPassword] = useState<string>("");
  const { t } = useTranslation("courseCard");

  useToastEffect({
    isSuccess,
    isError: false,
    successMessage: t("courseCard.successEnroll", {
      courseName: course.name,
      ns: "toast",
    }),
  });

  // biome-ignore lint/correctness/useExhaustiveDependencies: TODO fix dependencies
  useEffect(() => {
    if (isSuccess) {
      closeModal(ENROLL_COURSE_MODAL_ID);
      closeModal(SEARCH_MODAL_ID);
      setPassword("");
      reset();
    }
  }, [isSuccess]);

  // biome-ignore lint/correctness/useExhaustiveDependencies: TODO fix dependencies
  useEffect(() => {
    if (resetMask) {
      setPassword("");
      reset();
    }
  }, [resetMask]);

  return (
    <div className="flex min-h-28 flex-col justify-center">
      <form
        onSubmit={(e) => {
          e.preventDefault();
          if (course.id) {
            enrollCourse({ courseId: course.id, password });
          }
        }}
        className="mt-md flex flex-col justify-between gap-4"
      >
        <PasswordInput
          onChange={(e) => setPassword(e.target.value)}
          minLength={1}
          value={password}
          isError={isError}
        />

        <button
          type="submit"
          className="btn btn-primary min-w-32 max-w-64 self-center"
        >
          {t("enroll")}
        </button>
      </form>
    </div>
  );
};
